module.exports = __webpack_public_path__ + "img/nsmb-sunlei-2019.77e26312.png";